// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3ieop","item":"PaymentsMobile_item__TE4y0","label":"PaymentsMobile_label__BF5x4","amount":"PaymentsMobile_amount__3oY1o"};